var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7309_1724)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9934 23.9437C15.5409 23.9437 18.7279 22.4009 20.9203 19.9494C19.9004 19.063 18.3636 19.0091 17.278 19.8853L17.0705 20.0526C15.0828 21.6565 12.1863 21.4196 10.4855 19.514C9.55788 18.4746 7.96924 18.3686 6.91164 19.2753L4.52031 21.3255C6.56846 22.9639 9.16649 23.9437 11.9934 23.9437ZM15.875 18.1465C17.7684 16.6188 20.4295 16.6736 22.2506 18.1491C23.3391 16.3457 23.9653 14.2319 23.9653 11.9718C23.9653 9.46056 23.1921 7.1299 21.8707 5.2049C21.0188 5.02348 20.0956 5.23536 19.3946 5.85644L19.1952 6.03321C17.2835 7.72724 14.3792 7.62428 12.5923 5.79919C11.6177 4.8038 10.0259 4.77111 9.01123 5.72568L6.22843 8.34369L4.69758 6.71651L7.48038 4.09848C9.38103 2.31035 12.363 2.37159 14.1886 4.23622C15.1425 5.21053 16.693 5.26549 17.7135 4.36115L17.9129 4.18438C18.5324 3.63545 19.2491 3.26537 19.9996 3.07074C17.8785 1.16176 15.0716 0 11.9934 0C5.91601 0 0.896308 4.52843 0.124441 10.3951C1.97039 9.50926 4.24734 9.85012 5.75245 11.3914C6.70263 12.3644 8.23256 12.4671 9.30427 11.6299L10.8602 10.4143C12.8156 8.88665 15.5798 8.96058 17.4507 10.5907L20.4799 13.2298L19.0124 14.9143L15.9832 12.2751C14.9193 11.3482 13.3475 11.3062 12.2356 12.1748L10.6797 13.3904C8.71066 14.9287 5.89976 14.74 4.15404 12.9523C3.13891 11.9127 1.47865 11.8765 0.419096 12.8707L0.0823975 13.1866C0.334374 15.6871 1.3558 17.9605 2.90629 19.7664L5.45751 17.5792C7.4387 15.8807 10.4146 16.0795 12.1523 18.0264C13.0603 19.0436 14.6064 19.1701 15.6676 18.3139L15.875 18.1465Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7309_1724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSei);
export default __webpack_public_path__ + "static/media/sei.00a57f9c776437c9a0d1a34c77e7429e.svg";
export { ForwardRef as ReactComponent };